import styled from "styled-components";
import { GoToLogin } from "../register/styles";

export const LoginWrapper = styled.div``

export const LoginForm = styled.form``

export const GoToRegister = styled(GoToLogin)``